<template>
  <v-dialog :model-value="dialog" @update:model-value="$emit('update:dialog', $event)" max-width="800px">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h5">Crear un nuevo sprint</span>
        <v-btn icon @click="closeWindow">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-textarea v-model="sprint.description" label="Descripción del sprint" maxlength="500" required></v-textarea>
          
          <v-row>
            <v-col>
              <v-text-field v-model="sprint.startDate" label="Fecha de inicio" type="date"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field v-model="sprint.endDate" label="Fecha de término" type="date"></v-text-field>
            </v-col>
          </v-row>
        </v-form>

        <v-row>
          <v-col>
            <h3>Product Backlog</h3>
            <div class="backlog-column" @dragover.prevent @drop="onDrop('product')">
              <div 
                v-for="element in productBacklog" 
                :key="element._id" 
                :class="['backlog-item', { 'no-puntaje': element.puntaje <= 0 }]"
                draggable="true" 
                @dragstart="onDragStart(element)"
                @click="showCard(element)">
                {{ element.description }}
                <div class="backlog-item-footer">
                  <span>Estado: {{ element.state }}</span>
                  <span>Puntaje: {{ element.puntaje }}</span>
                </div>
              </div>
            </div>
          </v-col>
          <v-col>
            <h3>Sprint Backlog</h3>
            <div class="backlog-column" @dragover.prevent @drop="onDrop('sprint')">
              <div 
                v-for="element in sprintBacklog" 
                :key="element._id" 
                :class="['backlog-item', { 'no-puntaje': element.puntaje <= 0 }]"
                draggable="true" 
                @dragstart="onDragStart(element)">
                {{ element.description }}
                <div class="backlog-item-footer">
                  <span>Estado: {{ element.state }}</span>
                  <span>Puntaje: {{ element.puntaje }}</span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="send">Crear sprint</v-btn>
        <v-btn text @click="closeWindow">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api";

export default {
  name: "NewSprintComponent",
  props: {
    dialog: Boolean,
  },
  computed: {
    project() {
      return this.$store.state.project || {};
    },
    selectedCard(){
      return this.$store.state.selectedCard;
    },
    productBacklog: {
      get() {
        return this.$store.state.productBacklog;
      },
      set(value) {
        this.$store.commit("setProductBacklog", value);
      },
    },
    sprintBacklog: {
      get() {
        return this.$store.state.sprintBacklog;
      },
      set(value) {
        this.$store.commit("setSprintBacklog", value);
      },
    },
  },
  data() {
    return {
      sprint: {
        description: "",
        startDate: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        endDate: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000 + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
      },
      draggedElement: null,
    };
  },
  methods: {
    closeWindow() {
      this.$emit("update:dialog", false);
    },
    async fetchElements() {
      try {
        const projectId = this.$route.params.projectId;
        const response = await api.get(`/api/element/compromiso/project/${projectId}`);
        const elements = response.data;

        this.productBacklog = elements.filter(element => {
          const isInFirstColumn = element.state === this.project.kanbanColumns[0];
          const isNotInSprint = element.sprint === null || element.sprint === undefined;
          return isInFirstColumn && isNotInSprint;
        });
      } catch (error) {
        console.error("Error al obtener los elementos:", error);
      }
    },
    onDragStart(element) {
      if (element.puntaje > 0) {
        this.draggedElement = element;
      } else {
        this.$store.commit("setSnackbar", {
          text: "No puedes agregar elementos sin puntaje al sprint",
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
    },
    onDrop(column) {
      if (this.draggedElement) {
        if (column === 'product') {
          this.productBacklog.push(this.draggedElement);
          this.sprintBacklog = this.sprintBacklog.filter(el => el._id !== this.draggedElement._id);
        } else if (column === 'sprint') {
          this.sprintBacklog.push(this.draggedElement);
          this.productBacklog = this.productBacklog.filter(el => el._id !== this.draggedElement._id);
        }
        this.draggedElement = null;
      }
    },
    async send() {
      if (!this.sprint.description || !this.sprint.startDate || !this.sprint.endDate) {
        this.$store.commit("setSnackbar", {
          text: "Por favor completa todos los campos del sprint",
          color: "error",
          icon: "mdi-alert-circle",
        });
        return;
      }

      // Calcular el puntaje total del sprint
      this.sprint.totalPoints = this.sprintBacklog.reduce((acc, el) => acc + el.puntaje, 0);
      this.sprint.project = this.$route.params.projectId;
      this.sprint.history = [
        {
          date: new Date().toISOString(),
          pointsLeft: this.sprint.totalPoints,
        }
      ]

      console.log('objeto a enviar: ',this.sprint);

      try {
        const sprintResponse = await api.post(`/api/sprint/create`,this.sprint);
        const sprintId = sprintResponse.data._id;

        for (const element of this.sprintBacklog) {
          await api.put(`/api/element/update/${element._id}`,{ sprint: sprintId });
        }

        this.$store.commit("setSnackbar", {
          text: "Sprint creado exitosamente",
          color: "success",
          icon: "mdi-check-circle",
        });
      } catch (error) {
        console.error("Error al enviar el sprint:", error);
        this.$store.commit("setSnackbar", {
          text: "Error al crear el sprint",
          color: "error",
          icon: "mdi-alert-circle",
        });
      }

      this.closeWindow();
    },
    showCard(element) {
      this.$store.commit('setSelectedCard', element);
      this.$store.commit("switchTrelloCard");
    }
  },
  async created() {
    await this.fetchElements();
  },
};
</script>

<style scoped>
.backlog-column {
  border: 1px solid #ccc;
  min-height: 200px;
  padding: 10px;
  background-color: #f9f9f9;
}

.backlog-item {
  padding: 10px;
  margin: 5px 0;
  background-color: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
}

.backlog-item-footer {
  margin-top: 10px;
  font-size: 12px;
  color: #666;
  display: flex;
  justify-content: space-between;
}

.no-puntaje {
  background-color: #ffcccc;
}
</style>
